var map = {
	"./About 1.jpg": 8990,
	"./IMAG0035.jpg": 7848,
	"./IMAG0036.jpg": 6519,
	"./Image(055).jpg": 2392,
	"./Mandir-top_18.09.013.jpg": 5696,
	"./about2.jpg": 6561,
	"./aboutus3.jpg": 6336,
	"./aboutus4.jpg": 7987,
	"./aboutus5.jpg": 9462,
	"./green bldg 2.JPG": 2957,
	"./old age home at rohtak.jpg": 8977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2301;